






































import Vue from 'vue'
import { keyBy } from 'lodash'
import Artifacts from '@/components/artifacts/Artifacts.tsx'

// CBT
// ---
// P3
import ActivitiesDiary from '@/views/treatment/depression/cbt/activities-diary/DiaryEditor.vue'

// P5
import ReframingsDiary from '@/views/treatment/depression/cbt/reframings-diary/DiaryEditor.vue'

// P6
import ThoughtsDiary from '@/views/treatment/depression/cbt/thoughts-diary/DiaryEditor.vue'

// IPT
// ---
// P3
import ConflictsDiary from '@/views/treatment/depression/ipt/conflicts-diary/DiaryEditor.vue'

// P5
import RelationshipsDiary from '@/views/treatment/depression/ipt/relationships-diary/DiaryEditor.vue'

// P6
import StrategiesDiary from '@/views/treatment/depression/ipt/strategies-diary/DiaryEditor.vue'

import { CaseWithMessages } from '@/queries/cases.graphql'

export default Vue.extend({
  components: {
    Artifacts,
    ActivitiesDiary,
    ConflictsDiary,
    ReframingsDiary,
    RelationshipsDiary,
    StrategiesDiary,
    ThoughtsDiary,
  },
  apollo: {
    pickedCase: {
      query() {
        return CaseWithMessages
      },
      fetchPolicy: 'no-cache',
      variables() {
        return {
          id: this.caseId,
        }
      },
    },
  },
  computed: {
    code(): string {
      return `p${this.number}`
    },
    letter(): any {
      const members = keyBy(this.pickedCase!.members!.nodes || [], 'userId')

      const matches: any[] = this.$store.getters['letters/filterBy']({
        case_id: this.caseId,
        code: this.code,
      })

      if (matches.length > 0) {
        const letter = matches[0]
        return { ...letter, by: members[letter.sender_id] }
      } else {
        return { body: '', by: {} } // no matching letter
      }
    },
  },
  mounted() {
    if (this.condition === 'cbt' && this.number == 3) {
      this.$store.dispatch({ type: 'cbtActivities/fetch' })
    } else if (this.condition === 'cbt' && this.number == 5) {
      this.$store.dispatch({ type: 'cbtReframings/fetch' })
    } else if (this.condition === 'cbt' && this.number == 6) {
      this.$store.dispatch({ type: 'cbtThoughts/fetch' })
    } else if (this.condition === 'ipt' && this.number == 3) {
      this.$store.dispatch({ type: 'iptConflicts/fetch' })
    } else if (this.condition === 'ipt' && this.number == 5) {
      this.$store.dispatch({ type: 'iptRelationships/fetch' })
    } else if (this.condition === 'ipt' && this.number == 6) {
      this.$store.dispatch({ type: 'iptSituations/fetch' })
    } else {
      this.$store.dispatch({ type: 'letters/pullObjects' })
    }
  },
  props: {
    caseId: {
      type: String,
      required: true,
    },
    number: {
      type: [String, Number],
      required: true,
      validator(value: string | number): boolean {
        return typeof value === 'number' || value === 'final' || !isNaN(parseInt(value, 10))
      },
    },
    condition: {
      type: String,
      required: true,
      validator(value: string) {
        return ['ipt', 'cbt', 'cr', 'expo', 'counseling'].includes(value)
      },
    },
  },
})
